import { chakra } from "@chakra-ui/react"
import { inputRecipe } from "../../themes"

// Native <select> sharing the Input recipe so dropdowns and text inputs are
// visually identical. Native (rather than a custom listbox) is deliberate: it
// gets mobile's built-in wheel picker, type-ahead, and screen-reader support for
// free, which matters most on the long country list in the bank-details form.
export const Select = chakra("select", inputRecipe)
